import  {  timeline }  from './dist/timeline';

/**
 * Timeline
 */
export const Timeline = (function () {

  var init = function () {
    timeline(document.querySelectorAll('.timeline')); 
    addEventListeners();
  }

  function addEventListeners() {
    // Get the Twig Events data and parse for use
    var element = $('.timeline');
    if( element ){
      var timeline_data = element.attr("data-items");
      timeline_data = JSON.parse(timeline_data);
    }

    // Populate the timeline event modal when clicked
    $('.timeline_item').on('click', function(event) {
      // Gets the id of the timeline element clicked
      var timeline_item_id = event.target.id;

      // Loops through timeline events data to find matching id
      var result = timeline_data.find(entry => entry.id == timeline_item_id);

      // Add text to the modal
      $('.modal-title').text(result.title);
      $('.time-of-event').text(result.start_timestamp);
      $('.organiser').text("Organised by: " + result.organiser);
      $('.location').text("Location: " + result.location);
      $('.description').text(result.description);
    })
  }

  return {
    init: init
  }

}());


